import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import Header from './Header';
import FormSuggestTopic from '../forms/FormSuggestTopic';
import FormSuggestName from '../forms/FormSuggestName';
// import FormSelectSearch from '../forms/FormSelectSearch';
import FormSelect from '../forms/FormSelect';
import FormInput from '../forms/FormInput';
import { setGdc, setSubject, setTopic, setCondition, setAuthorize, setUser, setType, setDoa, setSearch, setAction, setBook, setSearchName, setOrg, setBookDetail, setQuery, setSelectedTopic, setSelectedCondition } from '../../actions/doaAction';
import { setLoading } from '../../actions/authAction';
import util from '../../functions/Utilities';
import history from '../../history';
import api from '../../api/api';
import uri from '../../variables/uri';
import addImg from '../../images/add.png';
import NewReleaseModal from '../modals/NewReleaseModal';
import MessageModal from '../modals/MessageModal';

class Home extends React.Component {
    state = {
        action: this.props.action,
        gdc: this.props.gdc,
        name: this.props.user.userID,
        user: this.props.user,
        comCode: this.props.bookDetail.comCode,
        orgName: this.props.bookDetail.orgId,
        amount: this.props.amount,
        value: this.props.value,
        jl: this.props.jl,
        pl: this.props.pl,
        others: this.props.others,
        levelOne: this.props.levelOne,
        levelTwo: this.props.levelTwo,
        levelThree: this.props.levelThree,
        levelFour: this.props.levelFour,
        levelFive: this.props.levelFive,
        levelSix: this.props.levelSix,
        levelSeven: this.props.levelSeven,
        type: this.props.type,
        subjectList: this.props.subjectList,
        bookCode: this.props.bookCode,
        topicList: this.props.topicList,
        conditionList: this.props.conditionList,
        orgIdList: [],
        orgNameArr: ['Please select'],
        subjectArr: ['Please select Level 1'],
        topicArr: ['Please select Level 2'],
        conditionArr: ['Please select Level 3'],
        levelFourArr: ['Please select Level 4'],
        levelFiveArr: ['Please select Level 5'],
        levelSixArr: ['Please select Level 6'],
        levelSevenArr: ['Please select Level 7'],
        isLoading: true,
        isOpenNewRelease: false,
        isOpenMessage: false,
        message: '',
        selectedTopic: undefined,
        selectedCondition: undefined,
        doaException: [],
        selectedSubjectId: undefined,
        doaExceptionArr: ['Please select'],
        selectedDoaException: []
    }

    componentDidMount = async () => {
        this.type = this.props.type;
        if (!this.props.auth.isAuthen) {
            history.push('/');
        } else {
            this.props.setLoading(true);
            if (Object.entries(this.props.user).length === 0 && this.props.user.constructor === Object) {
                api.get(uri.GET_BOOK_LIST).then(bookList => {
                    if (bookList.status === 200) {
                        const bookArr = [];
                        bookList.data.forEach(item => {
                            bookArr.push(Object.entries(this.props.auth.role).length === 0 && this.props.auth.role.constructor === Object ? item.BookName : `${item.BookName} ver.${item.BookReleaseVersion}`);
                            // bookArr.push(`${item.BookName} ver.${item.BookReleaseVersion}`);
                        });
                        this.props.setQuery({ key: 'queryBookList', value: bookList.data });
                        this.props.setQuery({ key: 'queryBookArr', value: bookArr });
                        const userId = Object.entries(this.props.user).length === 0 && this.props.user.constructor === Object ? this.props.match.params.userId : this.props.user.UserID;
                        this.setState({ name: userId, isLoading: false });
                    }
                    api.get(`${uri.GET_FIND_GDC}?userId=${this.props.match.params.userId}`).then(gdc => {
                        this.props.setGdc(gdc.data.BusinessUnit);
                        this.setState({ gdc: gdc.data.BusinessUnit });
                    }).catch(ex => {
                        this.props.setLoading(false);
                    });
                    if(_.isEmpty(this.props.queryBook)){
                        this.onBookChange(this.props.queryBookArr[0]);
                        
                    }
                });
                
            } else {
                this.setState({ isLoading: false, name: this.props.user.UserID });
            }
        }
    }

    onGdcChange = (gdc) => {
        this.reset();
        this.props.setBook('');
        this.props.setTopic(['Please select Level 2']);
        this.props.setCondition(['Please select Level 3']);
        this.props.setGdc(gdc);
        this.props.setSearchName('');
        this.setState({ gdc, user: undefined, orgNameArr: ['Please select'], orgName: 'Please select' })
    }

    onNameChange = (name) => {
        this.setState({ name });
    }

    onDoaChange = (doa) => {
        if (doa === undefined) {
            this.reset();
        } else if (doa === 'keyChange') {
            this.reset(doa);
        } else {
            doa.TopicTitle = util.replaceAll(doa.TopicTitle, '<br/>', '');
            this.onTypeChange(doa.SubjectTypeTitle);
            this.levelOne = doa.SubjectTitle;
            this.onLevelOneChange(doa.SubjectTitle);
            this.setState({ doa: doa.TopicTitle });
            if (!doa.TopicNo.includes('.')) {
                this.onLevelTwoChange(doa.TopicNo + '. ' + doa.TopicTitle);
            } else {
                const found = this.state.topicList.find(topic => !topic.TopicNo.includes('.') && doa.TopicNo.substring(0, doa.TopicNo.indexOf('.')) === topic.TopicNo && doa.SubjectTitle === topic.SubjectTitle);
                this.onLevelTwoChange(found.TopicNo + '. ' + found.TopicTitle);
                this.onLevelThreeChange(util.replaceAll(doa.TopicNo + '. ' + doa.TopicTitle, '<br/>', ''));
            }
        }
    }

    onAmountChange = (amount) => {
        this.setState({ amount });
    }

    onValueChange = (value) => {
        this.setState({ value });
    }

    onPlChange = (pl) => {
        this.setState({ pl });
    }

    onJlChange = (jl) => {
        this.setState({ jl });
    }

    onOthersChange = (others) => {
        this.setState({ others });
    }

    onLevelOneChange = (selectedTitle) => {
        const arr = ['Please select Level 2'];
        this.state.topicList.forEach(element => {
            if (selectedTitle === element.SubjectTitle && element.SubjectTypeTitle === this.type) {
                if (!element.TopicNo.includes('.')) {
                    arr.push(element.TopicNo + ". " + element.TopicTitle);
                }
            }
        });
        this.levelOne = selectedTitle;
        let subjectId = -1
        this.state.subjectList.forEach(element => {
            if (element.SubjectTitle === selectedTitle) subjectId = element.SubjectID
        })
        this.setState({ selectedSubjectId: subjectId, amount: undefined, topicArr: arr, conditionArr: ['Please select Level 3'], levelFourArr: ['Please select Level 4'], levelFiveArr: ['Please select Level 5'], levelSixArr: ['Please select Level 6'], levelSevenArr: ['Please select Level 7'], levelOne: selectedTitle, levelTwo: 'Please select Level 2', levelThree: 'Please select Level 3', levelFour: 'Please select Level 4', levelFive: 'Please select Level 5', levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
        this.props.setSearch('');
    }

    onLevelTwoChange = (selectedTitle) => {
        const arr = ['Please select Level 3'];
        const found = this.state.topicList.find(topic => topic.TopicNo + ". " + topic.TopicTitle === selectedTitle);
        if (found !== undefined) {
            this.state.topicList.forEach(element => {
                if (this.levelOne === element.SubjectTitle && element.TopicNo !== found.TopicNo && element.TopicNo.substring(0, found.TopicNo.length + 1) === found.TopicNo + '.' && this.props.type === element.SubjectTypeTitle) {
                    if (this.countDot(element.TopicNo) === 1) {
                        arr.push(util.replaceAll(element.TopicNo + ". " + element.TopicTitle, '<br/>', ''));
                    }
                }
            });
            this.setState({ selectedTopic: found, amount: undefined, conditionArr: arr, levelFourArr: ['Please select Level 4'], levelFiveArr: ['Please select Level 5'], levelSixArr: ['Please select Level 6'], levelSevenArr: ['Please select Level 7'], levelTwo: selectedTitle, levelThree: 'Please select Level 3', levelFour: 'Please select Level 4', levelFive: 'Please select Level 5', levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
            this.checkDoaException(found)
        } else {
            const condition = this.state.conditionList.find(item => this.levelOne === item.SubjectTitle && this.selectedTopic.TopicID === item.TopicID && selectedTitle === item.ConditionTitle)
            this.setState({ selectedCondition: condition, levelTwo: selectedTitle, levelThree: 'Please select Level 3', levelFour: 'Please select Level 4', levelFive: 'Please select Level 5', levelSix: 'Please selectLevel 6', levelSeven: 'Please select Level 7' });
        }
        this.props.setSearch('');
    }

    onLevelThreeChange = (selectedTitle) => {
        const arr = ['Please select Level 4'];
        selectedTitle = util.replaceAll(selectedTitle, '<br/>', '')
        const found = this.state.topicList.find(topic => util.replaceAll(topic.TopicNo + ". " + topic.TopicTitle, '<br/>', '') === selectedTitle);
        if (found !== undefined) {
            this.state.topicList.forEach(element => {
                if (this.levelOne === element.SubjectTitle && element.TopicNo !== found.TopicNo && element.TopicNo.substring(0, found.TopicNo.length + 1) === found.TopicNo + '.' && this.props.type === element.SubjectTypeTitle) {
                    if (this.countDot(element.TopicNo) === 2) {
                        arr.push(util.replaceAll(element.TopicNo + ". " + element.TopicTitle, '<br/>', ''));
                    }
                }
            });
            if (arr.length === 1) {
                this.state.conditionList.forEach(element => {
                    if (this.levelOne === element.SubjectTitle && element.TopicNo === found.TopicNo && element.Type !== 'A') {
                        arr.push(element.ConditionTitle)
                    }
                })
            }
            this.setState({ selectedTopic: found, amount: undefined, levelFourArr: arr, levelFiveArr: ['Please select Level 5'], levelSixArr: ['Please select Level 6'], levelSevenArr: ['Please select Level 7'], levelThree: selectedTitle, levelFour: 'Please select Level 4', levelFive: 'Please select Level 5', levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
            this.checkDoaException(found)
        } else {
            const condition = this.state.conditionList.find(item => this.levelOne === item.SubjectTitle && this.selectedTopic.TopicID === item.TopicID && selectedTitle === item.ConditionTitle)
            this.setState({ selectedCondition: condition, levelThree: selectedTitle, levelFour: 'Please select Level 4', levelFive: 'Please select Level 5', levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
        }
        this.props.setSearch('');
    }

    onLevelFourChange = (selectedTitle) => {
        const arr = ['Please select Level 5'];
        selectedTitle = util.replaceAll(selectedTitle, '<br/>', '')
        const found = this.state.topicList.find(topic => util.replaceAll(topic.TopicNo + ". " + topic.TopicTitle, '<br/>', '') === selectedTitle);
        if (found !== undefined) {
            this.state.topicList.forEach(element => {
                if (this.levelOne === element.SubjectTitle && element.TopicNo !== found.TopicNo && element.TopicNo.substring(0, found.TopicNo.length + 1) === found.TopicNo + '.' && this.props.type === element.SubjectTypeTitle) {
                    if (this.countDot(element.TopicNo) === 2) {
                        arr.push(util.replaceAll(element.TopicNo + ". " + element.TopicTitle, '<br/>', ''));
                    }
                }
            });
            if (arr.length === 1) {
                this.state.conditionList.forEach(element => {
                    if (this.levelOne === element.SubjectTitle && this.levelOne === element.SubjectTitle && element.TopicNo === found.TopicNo && element.Type !== 'A') {
                        arr.push(element.ConditionTitle)
                    }
                })
            }
            this.setState({ selectedTopic: found, amount: undefined, levelFiveArr: arr, levelSixArr: ['Please select Level 6'], levelSevenArr: ['Please select Level 7'], levelFour: selectedTitle, levelFive: 'Please select Level 5', levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
            this.checkDoaException(found)
        } else {
            const condition = this.state.conditionList.find(item => this.levelOne === item.SubjectTitle && this.selectedTopic.TopicID === item.TopicID && selectedTitle === item.ConditionTitle)
            this.setState({ selectedCondition: condition, levelFour: selectedTitle, levelFive: 'Please select Level 5', levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
        }
        this.props.setSearch('');
    }

    onLevelFiveChange = (selectedTitle) => {
        const arr = ['Please select Level 6'];
        selectedTitle = util.replaceAll(selectedTitle, '<br/>', '')
        const found = this.state.topicList.find(topic => util.replaceAll(topic.TopicNo + ". " + topic.TopicTitle, '<br/>', '') === selectedTitle);
        if (found !== undefined) {
            this.state.topicList.forEach(element => {
                if (this.levelOne === element.SubjectTitle && element.TopicNo !== found.TopicNo && element.TopicNo.substring(0, found.TopicNo.length + 1) === found.TopicNo + '.' && this.props.type === element.SubjectTypeTitle) {
                    if (this.countDot(element.TopicNo) === 2) {
                        arr.push(util.replaceAll(element.TopicNo + ". " + element.TopicTitle, '<br/>', ''));
                    }
                }
            });
            if (arr.length === 1) {
                this.state.conditionList.forEach(element => {
                    if (this.levelOne === element.SubjectTitle && element.TopicNo === found.TopicNo && element.Type !== 'A') {
                        arr.push(element.ConditionTitle)
                    }
                })
            }
            this.setState({ selectedTopic: found, amount: undefined, levelSixArr: arr, levelSevenArr: ['Please select Level 7'], levelFive: selectedTitle, levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
            this.checkDoaException(found)
        } else {
            const condition = this.state.conditionList.find(item => this.levelOne === item.SubjectTitle && this.state.selectedTopic.TopicID === item.TopicID && selectedTitle === item.ConditionTitle)
            this.setState({ selectedCondition: condition, levelFive: selectedTitle, levelSix: 'Please select Level 6', levelSeven: 'Please select Level 7' });
        }
        this.props.setSearch('')
    }

    onLevelSixChange = (selectedTitle) => {
        const arr = ['Please select Level 7'];
        selectedTitle = util.replaceAll(selectedTitle, '<br/>', '')
        const found = this.state.topicList.find(topic => util.replaceAll(topic.TopicNo + ". " + topic.TopicTitle, '<br/>', '') === selectedTitle);
        if (found !== undefined) {
            this.state.topicList.forEach(element => {
                if (this.levelOne === element.SubjectTitle && element.TopicNo !== found.TopicNo && element.TopicNo.substring(0, found.TopicNo.length + 1) === found.TopicNo + '.' && this.props.type === element.SubjectTypeTitle) {
                    if (this.countDot(element.TopicNo) === 2) {
                        arr.push(util.replaceAll(element.TopicNo + ". " + element.TopicTitle, '<br/>', ''));
                    }
                }
            });
            if (arr.length === 1) {
                this.state.conditionList.forEach(element => {
                    if (this.levelOne === element.SubjectTitle && element.TopicNo === found.TopicNo && element.Type !== 'A') {
                        arr.push(element.ConditionTitle)
                    }
                })
            }
            this.setState({ selectedTopic: found, amount: undefined, levelSevenArr: arr, levelSix: selectedTitle, levelSeven: 'Please select Level 7' });
            this.checkDoaException(found)
        } else {
            const condition = this.state.conditionList.find(item => this.levelOne === item.SubjectTitle && this.selectedTopic.TopicID === item.TopicID && selectedTitle === item.ConditionTitle)
            this.setState({ selectedCondition: condition, levelSix: selectedTitle, levelSeven: 'Please select Level 7' });
        }
        this.props.setSearch('');
    }

    onLevelSevenChange = (selectedTitle) => {
        selectedTitle = util.replaceAll(selectedTitle, '<br/>', '')
        const condition = this.state.conditionList.find(item => this.levelOne === item.SubjectTitle && this.selectedTopic.TopicID === item.TopicID && selectedTitle === item.ConditionTitle)
        this.setState({ selectedCondition: condition, amount: undefined, levelSeven: selectedTitle });
        this.props.setSearch('');
    }

    checkDoaException = async (found) => {
        setTimeout(async () => {
            if (this.state.selectedTopic !== undefined) {
                const response = await api.get(`${uri.GET_DOA_EXCEPTION}?bookCode=${this.state.bookCode}&subjectId=${this.state.selectedSubjectId}&subjectType=${this.state.type === 'อำนาจทั่วไป / General' ? 1 : this.state.type === 'อำนาจเฉพาะ / Speciality' ? 2 : 3}&topicNo=${found.TopicNo}&bookSubjectId=${found.BookSubjectID}`)
                if (response !== undefined) {
                    const doaExceptionArr = ['Please select']
                    response.data.forEach(element => {
                        doaExceptionArr.push(element.ExceptionCode + ": " + element.ExceptionName)
                    });
                    this.setState({ doaException: response.data, doaExceptionArr })
                }
            }
        }, 100);
    }

    countDot(text) {
        var count = text.split('.').length
        return count - 1
    }

    onDoaExceptionChange = (value) => {
        if (this.state.selectedDoaException.includes(value)) {
        } else {
            this.setState(prevState => ({
                selectedDoaException: [...prevState.selectedDoaException, value]
            }))
        }
    }

    onTypeChange = (type) => {
        this.reset();
        this.setState({ type });
        this.type = type;
        this.props.setType(type);
        const subjectArr = ['Please select Level 1'];
        this.state.subjectList.forEach(element => {
            this.state.topicList.forEach(item => {
                if (item.SubjectTitle === element.SubjectTitle && item.SubjectTypeTitle === type) {
                    subjectArr.push(element.SubjectTitle);
                }
            });
        });
        this.setState({ subjectArr: _.uniqBy(subjectArr) });
    }

    onOrgNameChange = (orgName) => {
        const selected = this.state.orgIdList.find(item => item.OrganizationName === orgName);
        this.setState({ comCode: selected.CompanyCode, orgName: selected.OrganizationName });
        this.getBookCode(selected.CompanyCode, selected.OrganizationId);
    }

    onBookChange = async (book) => {
        const found = this.props.queryBookList.find(item => item.BookName === util.validateBookName(book));
        this.props.setQuery({ key: 'queryBook', value: found });
        try {
            const topicResponse = await api.get(`${uri.GET_TOPIC_LIST}?BookCode=${found.BookCode}`);
            const conditionResponse = await api.get(`${uri.GET_CONDITION_LIST}?BookReleaseId=${found.BookReleaseId}`);
            if (topicResponse.status === 200 && conditionResponse.status === 200) {
                this.props.setQuery({ key: 'queryTopicList', value: _.sortBy(topicResponse.data, 'TopicNo') });
                this.props.setQuery({ key: 'queryConditionList', value: conditionResponse.data });
                const subjectArr = ['Please select Level 1'];
                this.state.subjectList.forEach(element => {
                    topicResponse.data.forEach(item => {
                        if (item.SubjectTitle === element.SubjectTitle && item.SubjectTypeTitle === this.type) {
                            subjectArr.push(element.SubjectTitle);
                        }
                    });
                });
                this.setState({ subjectArr: _.uniqBy(subjectArr), topicList: topicResponse.data, conditionList: conditionResponse.data });
            }
        } catch (ex) {
            this.setState({ topicList: [], conditionList: [] });
        }
    }

    onHandleSelect = async (user) => {
        if (user === undefined) {
            this.setState({ user, orgNameArr: ['Please select'], orgName: 'Please select' })
        } else {
            if ((Object.entries(this.props.user).length === 0 && this.props.user.constructor === Object) || user !== this.props.user) {
                this.props.setLoading(true);
                this.props.setUser(user);
                this.setState({ user, name: `${user.FirstNameEN} ${user.LastNameEN}` });
                const memberInfo = await api.post(uri.POST_MEMBER_INFO, { Gdc: this.state.gdc, UserID: user.UserID });
                if (memberInfo.status === 200) {
                    this.props.setOrg(memberInfo.data);
                    const orgNameArr = [];
                    const uniqMemberInfo = _.uniqBy(memberInfo.data, 'OrganizationId');
                    uniqMemberInfo.forEach(element => {
                        orgNameArr.push(element.OrganizationName ? element.OrganizationName : element.OrganizationId);
                        if (!element.OrganizationName) {
                            element.OrganizationName = element.OrganizationId
                        }
                    });
                    this.setState({ orgNameArr, orgIdList: uniqMemberInfo });
                    if (uniqMemberInfo.length === 1) {
                        this.setState({ comCode: uniqMemberInfo[0].CompanyCode, orgName: uniqMemberInfo[0].OrganizationName });
                        this.getBookCode(uniqMemberInfo[0].CompanyCode, uniqMemberInfo[0].OrganizationId);
                    }
                }
                this.props.setLoading(false);
            } else {
                this.setState({ user, name: `${user.FirstNameEN} ${user.LastNameEN}` });
                const orgNameArr = [];
                const uniqMemberInfo = _.uniqBy(this.props.orgList, 'OrganizationId');
                uniqMemberInfo.forEach(element => {
                    orgNameArr.push(element.OrganizationName);
                });
                this.setState({ orgNameArr, orgIdList: uniqMemberInfo });
                if (uniqMemberInfo.length === 1) {
                    this.setState({ comCode: uniqMemberInfo[0].CompanyCode, orgName: uniqMemberInfo[0].OrganizationName });
                    this.getBookCode(uniqMemberInfo[0].CompanyCode, uniqMemberInfo[0].OrganizationId);
                }
            }
        }
    }

    getBookCode = async (comCode, orgId) => {
        if (this.props.bookDetail.comCode === '' || this.props.bookDetail.orgId === '' || comCode !== this.props.bookDetail.comCode || orgId !== this.props.bookDetail.orgId) {
            this.props.setBookDetail({ comCode, orgId });
            const bookCodeResponse = await api.get(`${uri.GET_BOOK_CODE}?CompanyCode=${comCode}&OrganizationId=${orgId}`);
            if (bookCodeResponse.status === 200) {
                try {
                    const subjectResponse = await api.get(uri.GET_SUBJECT_LIST);
                    const topicResponse = await api.get(`${uri.GET_TOPIC_LIST}?BookCode=${bookCodeResponse.data.BookCode}`)
                    const conditionResponse = await api.get(`${uri.GET_CONDITION_LIST}?BookReleaseId=${bookCodeResponse.data.BookReleaseId}`)
                    if (subjectResponse.status === 200 && topicResponse.status === 200 && conditionResponse.status === 200) {
                        const subjectArr = ['Please select Level 1'];
                        subjectResponse.data.forEach(element => {
                            topicResponse.data.forEach(item => {
                                if (item.SubjectTitle === element.SubjectTitle && item.SubjectTypeTitle === this.type) {
                                    subjectArr.push(element.SubjectTitle);
                                }
                            });
                        });
                        this.props.setSubject(subjectResponse.data);
                        this.props.setTopic(topicResponse.data);
                        this.props.setCondition(conditionResponse.data);
                        this.props.setBook(bookCodeResponse.data.BookCode);
                        this.props.setQuery({ key: 'queryTopicList', value: topicResponse.data });
                        this.props.setQuery({ key: 'queryConditionList', value: conditionResponse.data });
                        this.props.setQuery({ key: 'queryBook', value: bookCodeResponse.data });
                        this.setState({ subjectList: subjectResponse.data, bookCode: bookCodeResponse.data.BookCode, topicList: topicResponse.data, conditionList: conditionResponse.data, subjectArr: _.uniqBy(subjectArr) });
                    }
                } catch (ex) {
                    this.setState({ topicList: [], conditionList: [] });
                }
            }
        } else {
            const topicList = this.state.action === 'authorize' ? this.props.topicList : this.props.queryTopicList;
            const subjectArr = ['Please select Level 1'];
            this.props.subjectList.forEach(element => {
                topicList.forEach(item => {
                    if (item.SubjectTitle === element.SubjectTitle && item.SubjectTypeTitle === this.type) {
                        subjectArr.push(element.SubjectTitle);
                    }
                });
            });
            this.setState({ subjectList: this.props.subjectList, bookCode: this.state.action === 'authorize' ? this.props.bookCode : this.props.queryBookCode, topicList: this.state.action === 'authorize' ? this.props.topicList : this.props.queryTopicList, conditionList: this.state.action === 'authorize' ? this.props.conditionList : this.props.queryConditionList, subjectArr: _.uniqBy(subjectArr) }, () => {
                this.onLevelOneChange(this.props.levelOne, this.props.levelTwo);
                this.onLevelTwoChange(this.props.levelTwo, this.props.levelThree);
                // this.onLevelThreeChange(this.props.levelThree);
            });
        }
        this.props.setLoading(false);
    }

    onActionChange = (action) => {
        this.props.setAction(action);
        this.setState({ action });
        this.reset();
        const subjectArr = ['Please select Level 1'];
        this.state.subjectList.forEach(element => {
            this.props.topicList.forEach(item => {
                if (item.SubjectTitle === element.SubjectTitle && item.SubjectTypeTitle === this.type) {
                    subjectArr.push(element.SubjectTitle);
                }
            });
        });
        this.setState({ subjectArr: _.uniqBy(subjectArr), topicList: this.props.topicList, conditionList: this.props.conditionList });
    }

    reset(key) {
        if (key === 'keyChange') {
            this.setState({ levelOne: 'Please select Level 1', levelTwo: 'Please select Level 2', levelThree: 'Please select Level 3', topicArr: ['Please select Level 2'], conditionArr: ['Please select Level 3'] });
        } else {
            this.props.setSearch('');
            this.props.setType('อำนาจทั่วไป / General');
            this.type = 'อำนาจทั่วไป / General';
            this.setState({ type: 'อำนาจทั่วไป / General', levelOne: 'Please select Level 1', levelTwo: 'Please select Level 2', levelThree: 'Please select Level 3', topicArr: ['Please select Level 2'], conditionArr: ['Please select Level 3'] });
        }
    }

    newRelease = () => {
        this.setState({ isOpenNewRelease: true });
    }

    onNewReleaseModalClose = () => {
        this.setState({ isOpenNewRelease: false });
    }

    goToDoaBook = () => {
        this.setState({ isOpenMessage: false, message: '' });
        history.push(`/ManageDoa/${this.props.match.params.userId}`);
    }

    onNewReleaseSuccess = () => {
        this.setState({ isOpenMessage: true, message: 'Created new release successful.' });
        api.get(uri.GET_BOOK_LIST).then(bookList => {
            if (bookList.status === 200) {
                const bookArr = [];
                bookList.data.forEach(item => {
                    bookArr.push(Object.entries(this.props.auth.role).length === 0 && this.props.auth.role.constructor === Object ? item.BookName : `${item.BookName} ver.${item.BookReleaseVersion}`);
                    // bookArr.push(`${item.BookName} ver.${item.BookReleaseVersion}`);
                });
                this.props.setQuery({ key: 'queryBookList', value: bookList.data });
                this.props.setQuery({ key: 'queryBookArr', value: bookArr });
            }
        });
    }

    onSubmit = async () => {
        if (this.state.action === 'ManageDoa') {
            this.props.setDoa({ levelOne: this.state.levelOne, levelTwo: this.state.levelTwo, levelThree: this.state.levelThree, levelFour: this.state.levelFour, levelFive: this.state.levelFive, levelSix: this.state.levelSix, levelSeven: this.state.levelSeven });
            history.push(`/ManageDoa/${this.props.match.params.userId}`);
        } else if (this.state.action === 'authorize') {
            this.props.setLoading(true);
            const selected = this.state.orgIdList.find(item => item.OrganizationName === this.state.orgName);
            console.log({ levelOne: this.state.levelOne, levelTwo: this.state.levelTwo, levelThree: this.state.levelThree, levelFour: this.state.levelFour, levelFive: this.state.levelFive, levelSix: this.state.levelSix, levelSeven: this.state.levelSeven })
            this.props.setSelectedTopic(this.state.selectedTopic);
            this.props.setSelectedCondition(this.state.selectedCondition)
            // if (this.state.selectedTopic.Type !== 'A') {
            //     this.props.setLoading(false);
            //     this.setState({ isOpenMessage: true, message: 'Unable to support this topic, please check DOA book.' })
            // } else {
            try {
                var body = {
                    Gdc: this.state.gdc,
                    CompanyCode: this.state.comCode,
                    OrganizationId: selected.OrganizationId,
                    UserID: this.state.user.UserID,
                    Amount: this.state.amount,
                    Value: this.state.value,
                    JL: this.state.jl,
                    PL: this.state.pl,
                    Others: this.state.others,
                    ConditionDetailID: this.state.selectedCondition !== undefined ? this.state.selectedCondition.ConditionDetailID : undefined,
                    Detail: this.state.selectedCondition === undefined ? [
                        {
                            BookCode: this.props.bookCode,
                            SubjectId: this.state.selectedTopic.SubjectID,
                            TopicNo: this.state.selectedTopic.TopicNo,
                            Type: this.props.type.includes('ทั่วไป') ? 1 : this.props.type.includes('เฉพาะ') ? 2 : 3
                        }
                    ] : undefined,
                    ExceptionCode: this.state.selectedDoaException.length > 0 ? this.state.selectedDoaException : undefined
                }
                var authorize = await api.post(uri.POST_AUTHORIZE, body);
                if (authorize.status === 200) {
                    this.props.setLoading(false);
                    this.props.setDoa({ levelOne: this.state.levelOne, levelTwo: this.state.levelTwo, levelThree: this.state.levelThree, levelFour: this.state.levelFour, levelFive: this.state.levelFive, levelSix: this.state.levelSix, levelSeven: this.state.levelSeven });
                    this.props.setAuthorize(authorize.data);
                    history.push(`/authorize/${this.props.match.params.userId}`);
                }
            } catch (ex) {
                this.props.setLoading(false); 
                this.setState({ isOpenMessage: true, message: 'Employee or Organization could not be found.' });
            }
            // }
        }
    }

    render() {
        return (
            <div className="home flex-v">
                <Header user={this.state.user} />
                <div className="flex-v flex-center">
                    <div className="tabs is-toggle is-toggle-rounded pt-16">
                        <ul>
                            <li onClick={() => this.onActionChange('authorize')} className={`${this.state.action === 'authorize' && 'is-active'}`}>
                                <a>
                                    <h3>Check Authorized</h3>
                                </a>
                            </li>
                            <li onClick={() => this.onActionChange('ManageDoa')} className={`${this.state.action === 'ManageDoa' && 'is-active'}`}>
                                <a>
                                    <h3 className="has-text-centered" style={{ minWidth: '112px' }}>DOA Book</h3>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="flex-v flex-1">
                    <div className="flex-v flex-1 pl-24 pr-24">
                        {!this.state.isLoading &&
                            <div className={`${this.state.action === 'ManageDoa' && 'none'}`}>
                                <div className="flex-v">
                                    <FormSelect
                                        name="Business Unit"
                                        value={this.state.gdc}
                                        options={['CORPORATE', 'PACKAGING', 'CHEMICALS', 'CBM']}
                                        onValueChange={this.onGdcChange} />

                                        {/* <div className="flex-v mt-16">
                                        <FormSelectSearch />
                                        </div> */}
                                        
                                    <FormSuggestName
                                        name="Employee Name / Email"
                                        handleSelect={this.onHandleSelect}
                                        value={this.state.name} />
                                    <FormSelect
                                        disabled={this.state.orgName === 'Please select' && this.state.orgNameArr.length === 0}
                                        name="Organization"
                                        value={this.state.orgName}
                                        options={this.state.orgNameArr}
                                        onValueChange={this.onOrgNameChange} />
                                </div>
                            </div>
                        }
                        <div className="flex-v bg-grey-lighter pl-16 pr-16 pb-16 mt-16" style={{ borderRadius: '10px' }}>
                            {this.props.action === 'ManageDoa' &&
                                <div className="flex-h">
                                    <div className="flex-1">
                                        <FormSelect
                                            name="DOA Book"
                                            value={Object.entries(this.props.auth.role).length === 0 && this.props.auth.role.constructor === Object ? this.props.queryBook.BookName : `${this.props.queryBook.BookName} ver.${this.props.queryBook.BookReleaseVersion}`}
                                            options={this.props.queryBookArr}
                                            onValueChange={this.onBookChange} />
                                    </div>
                                    {this.props.auth.role.Release &&
                                        <div className="flex-h" style={{ alignItems: 'flex-end' }}>
                                            <div className="tooltip">
                                                <img onClick={() => this.newRelease()} className="button-add ml-8" src={addImg} alt="" />
                                                <span className="tooltiptext">New Release</span>
                                            </div>

                                        </div>
                                    }
                                </div>
                            }
                            {window.innerWidth >= 768 && <div className="flex-h mt-16" style={{ alignItems: 'center' }}>
                                <h4>Type :</h4>
                                <div className="flex-v ml-40">
                                    <div className="tabs is-toggle is-toggle-rounded">
                                        <ul>
                                            <li onClick={() => this.onTypeChange('อำนาจทั่วไป / General')} className={`${this.type === 'อำนาจทั่วไป / General' && 'is-active'}`}>
                                                <a>
                                                    <h3>อำนาจทั่วไป / General</h3>
                                                </a>
                                            </li>
                                            <li onClick={() => this.onTypeChange('อำนาจเฉพาะ / Speciality')} className={`${this.type === 'อำนาจเฉพาะ / Speciality' && 'is-active'}`}>
                                                <a>
                                                    <h3>อำนาจเฉพาะ / Speciality</h3>
                                                </a>
                                            </li>
                                            <li onClick={() => this.onTypeChange('พิเศษ / Extra')} className={`${this.type === 'พิเศษ / Extra' && 'is-active'}`}>
                                                <a>
                                                    <h3>พิเศษ / Extra</h3>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>}
                            {window.innerWidth < 768 && (
                                <div className="flex-h mt-16" style={{ alignItems: 'center', overflowX: 'auto' }}>
                                    <h4>Type :</h4>
                                    <div className="flex-v ml-40">
                                        <div className="tabs is-toggle is-toggle-rounded">
                                            <ul className="tabs-list" style={{ whiteSpace: 'nowrap' }}>
                                                <li onClick={() => this.onTypeChange('อำนาจทั่วไป / General')} className={`${this.type === 'อำนาจทั่วไป / General' && 'is-active'}`} style={{ display: 'inline-block', marginRight: '10px' }}>
                                                    <a>
                                                        <h3>อำนาจทั่วไป / General</h3>
                                                    </a>
                                                </li>
                                                <li onClick={() => this.onTypeChange('อำนาจเฉพาะ / Speciality')} className={`${this.type === 'อำนาจเฉพาะ / Speciality' && 'is-active'}`} style={{ display: 'inline-block', marginRight: '10px' }}>
                                                    <a>
                                                        <h3>อำนาจเฉพาะ / Speciality</h3>
                                                    </a>
                                                </li>
                                                <li onClick={() => this.onTypeChange('พิเศษ / Extra')} className={`${this.type === 'พิเศษ / Extra' && 'is-active'}`} style={{ display: 'inline-block', marginRight: '10px' }}>
                                                    <a>
                                                        <h3>พิเศษ / Extra</h3>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* <div className="flex-h mt-16" style={{ alignItems: 'center' }}>
                                <h4>Type :</h4>
                                <div className="flex-v ml-40">
                                    <div className="tabs is-toggle is-toggle-rounded">
                                        <ul>
                                            <li onClick={() => this.onTypeChange('อำนาจทั่วไป / General')} className={`${this.type === 'อำนาจทั่วไป / General' && 'is-active'}`}>
                                                <a>
                                                    <h3>อำนาจทั่วไป / General</h3>
                                                </a>
                                            </li>
                                            <li onClick={() => this.onTypeChange('อำนาจเฉพาะ / Speciality')} className={`${this.type === 'อำนาจเฉพาะ / Speciality' && 'is-active'}`}>
                                                <a>
                                                    <h3>อำนาจเฉพาะ / Speciality</h3>
                                                </a>
                                            </li>
                                            <li onClick={() => this.onTypeChange('พิเศษ / Extra')} className={`${this.type === 'พิเศษ / Extra' && 'is-active'}`}>
                                                <a>
                                                    <h3>พิเศษ / Extra</h3>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                            <FormSuggestTopic
                                name="Search Topic"
                                handleSelect={this.onDoaChange}
                                placeholder='เช่น หนี้ที่มีเอกสารประกอบ, การเบิกเงินทดรองจ่ายต่อครั้ง' />
                            <FormSelect
                                disabled={(this.state.subjectArr.length <= 1) || (this.props.action === 'authorize' && this.props.bookCode === '') || (this.props.action === 'ManageDoa' && Object.entries(this.props.queryBook).length === 0 && this.props.queryBook.constructor === Object)}
                                value={this.state.levelOne}
                                options={this.state.subjectArr}
                                onValueChange={this.onLevelOneChange} />
                            <FormSelect
                                disabled={this.state.levelOne === 'Please select Level 1'}
                                value={this.state.levelTwo}
                                options={this.state.topicArr}
                                onValueChange={this.onLevelTwoChange} />
                            {this.state.conditionArr.length > 1 &&
                                <FormSelect
                                    disabled={this.state.levelTwo === 'Please select Level 2'}
                                    value={this.state.levelThree}
                                    options={this.state.conditionArr}
                                    onValueChange={this.onLevelThreeChange} />
                            }
                            {this.state.levelFourArr.length > 1 &&
                                <FormSelect
                                    disabled={this.state.levelThree === 'Please select Level 3'}
                                    value={this.state.levelFour}
                                    options={this.state.levelFourArr}
                                    onValueChange={this.onLevelFourChange} />
                            }
                            {this.state.levelFiveArr.length > 1 &&
                                <FormSelect
                                    disabled={this.state.levelFour === 'Please select Level 4'}
                                    value={this.state.levelFive}
                                    options={this.state.levelFiveArr}
                                    onValueChange={this.onLevelFiveChange} />
                            }
                            {this.state.levelSixArr.length > 1 &&
                                <FormSelect
                                    disabled={this.state.levelFive === 'Please select Level 5'}
                                    value={this.state.levelSix}
                                    options={this.state.levelSixArr}
                                    onValueChange={this.onLevelSixChange} />
                            }
                            {this.state.levelSevenArr.length > 1 &&
                                <FormSelect
                                    disabled={this.state.levelSix === 'Please select Level 6'}
                                    value={this.state.levelSeven}
                                    options={this.state.levelSevenArr}
                                    onValueChange={this.onLevelSevenChange} />
                            }
                            {/* {this.state.doaException.map((item) => {
                              
                                return <div className="flex-h mt-8" style={{alignItems: 'center'}}>
                                    <input style={{ width: '75px' }} type="checkbox" onChange={() => this.onDoaExceptionChange(item.ExceptionCode)}></input>
                                    <div>{`${item.ExceptionCode}. ${item.ExceptionName}`}</div>
                                </div>
                            })} */}
                        </div>
                        {
                            (!this.state.isLoading && this.state.selectedTopic !== undefined) &&
                            <div className={`${this.state.action === 'ManageDoa' && 'none'}`}>
                                <FormInput
                                    name="Amount (THB)"
                                    value={this.state.amount}
                                    onValueChange={this.onAmountChange}
                                    type="number" />
                                <FormInput
                                    name="Value (THB)"
                                    value={this.state.value}
                                    onValueChange={this.onValueChange}
                                    type="number" />
                                <FormInput
                                    name="PL"
                                    value={this.state.pl}
                                    onValueChange={this.onPlChange}
                                    type="text" />
                                <FormInput
                                    name="JL"
                                    value={this.state.jl}
                                    onValueChange={this.onJlChange}
                                    type="text" />
                                <FormInput
                                    name="Others"
                                    value={this.state.others}
                                    onValueChange={this.onOthersChange}
                                    type="text" />
                            </div>
                        }
                    </div>
                </div>
                <div className="flex-h p-16 mt-8">
                    <button onClick={() => this.onSubmit()} className="button is-success is-fullwidth center">Confirm</button>
                </div>
                {!!this.props.queryBook.BookName && <NewReleaseModal isOpen={this.state.isOpenNewRelease} onSuccess={this.onNewReleaseSuccess} bookName={Object.entries(this.props.auth.role).length === 0 && this.props.auth.role.constructor === Object ? this.props.queryBook.BookName : `${this.props.queryBook.BookName} ver.${this.props.queryBook.BookReleaseVersion}`} bookArr={this.props.queryBookArr} onClose={this.onNewReleaseModalClose} />}
                <MessageModal isOpen={this.state.isOpenMessage} message={this.state.message} onClose={this.goToDoaBook} text={`Confirm & Go to DOA Book`} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        gdc: state.doa.gdc,
        auth: state.auth,
        user: state.doa.user,
        amount: state.doa.amount,
        type: state.doa.type,
        action: state.doa.action,
        subjectList: state.doa.subjectList,
        topicList: state.doa.topicList,
        conditionList: state.doa.conditionList,
        bookCode: state.doa.bookCode,
        orgList: state.doa.orgList,
        bookDetail: state.doa.bookDetail,
        levelOne: state.doa.doa.levelOne,
        levelTwo: state.doa.doa.levelTwo,
        levelThree: state.doa.doa.levelThree,
        levelFour: state.doa.doa.levelFour,
        levelFive: state.doa.doa.levelFive,
        levelSix: state.doa.doa.levelSix,
        levelSeven: state.doa.doa.levelSeven,
        queryBook: state.doa.queryBook,
        queryBookList: state.doa.queryBookList,
        queryTopicList: state.doa.queryTopicList,
        queryConditionList: state.doa.queryConditionList,
        queryBookArr: state.doa.queryBookArr
    }
}

export default connect(mapStateToProps, {
    setGdc,
    setSubject,
    setTopic,
    setCondition,
    setAuthorize,
    setUser,
    setType,
    setDoa,
    setSearch,
    setAction,
    setBook,
    setSearchName,
    setOrg,
    setBookDetail,
    setLoading,
    setQuery,
    setSelectedTopic,
    setSelectedCondition
})(Home);